import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fiveseateronrentinshirdi() {



  const cardData =
  {
    keyword: '5 Seater Bus on Rent in Shirdi',
    heading: 'Sanavi Travels: 5 Seater Bus on Rent in Shirdi',
    headingDescription: 'Sanavi Travels offers reliable 5 Seater Bus on Rent in Shirdi, providing safe, comfortable, and convenient transportation for small groups, families, and pilgrims visiting the holy town of Shirdi. Our fleet of well-maintained AC and non-AC mini buses and vans ensures smooth rides, ample seating, and enough luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Shirdi and nearby cities including Pune, Mumbai, Nashik, and Aurangabad, covering major attractions such as Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur. Choose Sanavi Travels for trusted 5 seater bus rental services in Shirdi, delivering comfort, safety, and a seamless travel experience for small groups and families.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is the primary spiritual attraction in Shirdi, dedicated to the revered saint Sai Baba. Millions of devotees visit every year seeking blessings, inner peace, and spiritual guidance. The temple is well-organized, facilitating smooth darshan and participation in sacred aartis."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir houses the tomb of Sai Baba and is the heart of the Shirdi temple complex. Devotees experience profound devotion and calm while offering prayers, making it the central spiritual spot in Shirdi."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived and performed miracles for decades. The continuously burning dhuni (sacred fire) symbolizes protection, faith, and devotion, attracting pilgrims throughout the year."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the historic location where Sai Baba used to rest on alternate nights. On Thursdays and during festivals, ceremonial processions are held, maintaining the traditional practices associated with Sai Baba’s life."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time in meditation and tending to plants. The continuously burning Nanda Deep lamp adds to the peaceful and spiritual atmosphere."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is historically important as the place where Sai Baba was first welcomed to Shirdi. It marks the beginning of Sai Baba’s spiritual journey in the town."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park that recreates key events from Sai Baba’s life using statues and traditional settings. It provides an educational and spiritual experience for visitors."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage commemorates one of Sai Baba’s closest disciples. Visitors come here to reflect on the deep spiritual bond between Sai Baba and his followers."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur, located nearby, is famous for its Lord Shani temple and the open-door village tradition. Many pilgrims visit Shani Shingnapur along with Shirdi for a complete spiritual experience."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers recreational fun with water rides, wave pools, and family entertainment. It provides a refreshing break for families visiting Shirdi alongside spiritual activities."
  }
]
,



"services": [
  {
    "name": "5 Seater Bus on Rent in Shirdi",
    "description": "5 Seater Bus on Rent in Shirdi provides a compact yet comfortable travel option for small groups, families, and couples visiting Shirdi. Fully air-conditioned, with ample legroom and professional chauffeurs, this service ensures a safe, smooth, and convenient journey. Ideal for short trips, temple visits, and personal travel, it combines affordability with comfort."
  },
  {
    "name": "Mini Bus Hire Shirdi",
    "description": "Mini Bus Hire Shirdi offers flexible rental options for small groups looking for organized and reliable transportation. Perfect for family outings, local tours, and group trips, these mini buses come with trained drivers to ensure timely pickups, safe travel, and a stress-free experience."
  },
  {
    "name": "AC Mini Bus Shirdi",
    "description": "AC Mini Bus Shirdi ensures a cool and relaxing journey even during long hours of travel. Equipped with air-conditioning, spacious seating, and professional chauffeurs, it provides a comfortable ride for families, small groups, and tourists traveling to Shirdi or nearby attractions."
  },
  {
    "name": "Small Bus Rental Shirdi",
    "description": "Small Bus Rental Shirdi caters to travelers seeking convenient and reliable transport for short or medium-distance trips. With well-maintained vehicles, skilled drivers, and flexible scheduling, this service is perfect for religious visits, family outings, and local sightseeing tours."
  },
  {
    "name": "Family Bus Shirdi",
    "description": "Family Bus Shirdi focuses on safe and comfortable travel for families visiting Shirdi. Air-conditioned interiors, spacious seating, and professional chauffeurs make journeys relaxing and enjoyable. Ideal for temple visits, day trips, and group excursions."
  },
  {
    "name": "Affordable Mini Bus Shirdi",
    "description": "Affordable Mini Bus Shirdi provides cost-effective transportation solutions for small groups and families. Without compromising comfort or safety, this service ensures smooth rides, reliable scheduling, and professional driving at budget-friendly prices."
  },
  {
    "name": "Chauffeur Driven Mini Bus",
    "description": "Chauffeur Driven Mini Bus offers a stress-free travel experience with experienced drivers handling navigation, traffic, and safety. Perfect for family outings, group trips, and corporate travel, it ensures a comfortable, reliable, and timely journey to Shirdi."
  },
  {
    "name": "Best Mini Bus Shirdi",
    "description": "Best Mini Bus Shirdi provides premium service for small groups with well-maintained vehicles, trained chauffeurs, and comfortable seating. Designed for families, tourists, and corporate travelers, it emphasizes punctuality, safety, and passenger satisfaction."
  },
  {
    "name": "Local Bus Shirdi",
    "description": "Local Bus Shirdi is ideal for short-distance travel within Shirdi and nearby areas. This service ensures quick, comfortable, and convenient rides for sightseeing, shopping, and local errands with reliable drivers and safe vehicles."
  },
  {
    "name": "Tourist Mini Bus Shirdi",
    "description": "Tourist Mini Bus Shirdi caters to travelers exploring Shirdi’s attractions and nearby temples. Air-conditioned mini buses with skilled drivers provide comfortable and organized sightseeing tours for families, groups, and pilgrims."
  },
  {
    "name": "Airport Pickup Bus Shirdi",
    "description": "Airport Pickup Bus Shirdi offers convenient and timely airport transfers for travelers heading to Shirdi. With professional chauffeurs, air-conditioned mini buses, and punctual service, it ensures a hassle-free journey from airports to Shirdi destinations."
  },
  {
    "name": "Online Bus Booking Shirdi",
    "description": "Online Bus Booking Shirdi allows users to reserve 5 seater or mini buses quickly and efficiently. Customers can choose dates, pickup points, and trip preferences with instant confirmation, ensuring a smooth and convenient travel experience to Shirdi."
  },
  {
    "name": "Group Travel Mini Bus",
    "description": "Group Travel Mini Bus is designed for small groups traveling together for religious tours, events, or family outings in Shirdi. Comfortable seating, air-conditioning, and professional drivers make group travel safe, organized, and enjoyable."
  },
  {
    "name": "Event Mini Bus Shirdi",
    "description": "Event Mini Bus Shirdi provides transport solutions for small gatherings, functions, or religious ceremonies. Air-conditioned mini buses with trained chauffeurs ensure punctuality, comfort, and convenience for event attendees traveling to Shirdi."
  },
  {
    "name": "Shirdi Travel Mini Bus",
    "description": "Shirdi Travel Mini Bus offers a reliable and flexible travel option for families, tourists, and small groups visiting Shirdi. With professional drivers, comfortable seating, and air-conditioned interiors, it ensures a smooth, safe, and enjoyable journey."
  }
],
"tableData": [
  ["5 Seater Bus on Rent in Shirdi", "Mini Bus Hire Shirdi"],
  ["AC Mini Bus Shirdi", "Small Bus Rental Shirdi"],
  ["Family Bus Shirdi", "Affordable Mini Bus Shirdi"],
  ["Chauffeur Driven Mini Bus", "Best Mini Bus Shirdi"],
  ["Local Bus Shirdi", "Tourist Mini Bus Shirdi"],
  ["Airport Pickup Bus Shirdi", "Online Bus Booking Shirdi"],
  ["Group Travel Mini Bus", "Event Mini Bus Shirdi"],
  ["Shirdi Travel Mini Bus", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "5 Seater Bus on Rent in Shirdi with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers 5‑seater buses on rent in Shirdi, perfect for small group travel, family outings, pilgrimages, local tours, and comfortable point‑to‑point transfers."
  },
  {
    "WhyChooseheading": "Compact and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced 5‑seater buses that ensure a smooth and enjoyable ride within Shirdi and nearby destinations."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local routes for safe and timely travel for your small group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for 5‑seater bus rentals in Shirdi, inclusive of fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last‑minute changes for your 5‑seater bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your travel schedule and small group requirements in Shirdi."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 5‑seater buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 5‑seater bus rentals in Shirdi."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 5‑seater buses on rent in Shirdi?',
    answer: 'Yes, Sanavi Travels offers 5‑seater bus rentals in Shirdi suitable for small group travel and family outings.'
  },
  {
    question: 'How can I book a 5‑seater bus in Shirdi?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the 5‑seater buses well‑maintained and air‑conditioned?',
    answer: 'Yes, all our 5‑seater buses are clean, air‑conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with local Shirdi routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with local routes for safe and timely transportation.'
  },
  {
    question: 'Can I rent the 5‑seater bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and customized rental packages to meet your travel needs.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all 5‑seater buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 5‑seater bus rental.'
  },
  {
    question: 'What payment options are available for 5‑seater bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for 5‑seater bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on‑time pickups and reliable service for all 5‑seater bus bookings in Shirdi.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Booked a 5‑seater bus in Shirdi for our small family trip. Comfortable ride and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent 5‑seater bus rental service. Clean vehicle, smooth journey, and very responsive support.',
    rating: 5
  }
];





















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "5 Seater Bus on Rent in Shirdi - Sanavi Travels",
  "description": "Sanavi Travels offers 5 seater mini bus rental services in Shirdi for family trips, small group travel, events, and airport pickups. AC and chauffeur-driven buses available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "120"
  }
};





  return (
    <div>
<Helmet>
  <title>
    5 Seater Bus on Rent in Shirdi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 5 seater mini bus in Shirdi with Sanavi Travels for family trips, small group travel, events, and airport pickups. AC and chauffeur-driven buses available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/177.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fiveseateronrentinshirdi;